var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7092_41084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 18.75C9.44036 18.75 10 18.1904 10 17.5C10 16.8096 9.44036 16.25 8.75 16.25C8.05964 16.25 7.5 16.8096 7.5 17.5C7.5 18.1904 8.05964 18.75 8.75 18.75Z",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 18.75C17.5654 18.75 18.125 18.1904 18.125 17.5C18.125 16.8096 17.5654 16.25 16.875 16.25C16.1846 16.25 15.625 16.8096 15.625 17.5C15.625 18.1904 16.1846 18.75 16.875 18.75Z",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 18.75C25.6904 18.75 26.25 18.1904 26.25 17.5C26.25 16.8096 25.6904 16.25 25 16.25C24.3096 16.25 23.75 16.8096 23.75 17.5C23.75 18.1904 24.3096 18.75 25 18.75Z",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.25C14.5606 1.25092 11.6765 2.0491 9.15486 3.55954C6.63322 5.06997 4.56849 7.23609 3.18059 9.82719C1.79268 12.4183 1.13358 15.3373 1.27347 18.2734C1.41337 21.2095 2.34702 24.0526 3.975 26.5L1.25 33.75L10.375 32.1C12.5723 33.1737 14.9836 33.7377 17.4291 33.7498C19.8747 33.7619 22.2914 33.2219 24.4992 32.17C26.707 31.118 28.6489 29.5813 30.1802 27.6745C31.7114 25.7676 32.7925 23.5396 33.3428 21.1568C33.8931 18.7739 33.8985 16.2976 33.3586 13.9123C32.8187 11.5271 31.7473 9.29447 30.2244 7.38092C28.7015 5.46736 26.7663 3.92222 24.5632 2.86068C22.36 1.79913 19.9456 1.24856 17.5 1.25V1.25Z",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7092_41084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.915a503846159303cee77220c2c946de.svg";
export { ForwardRef as ReactComponent };